import { webToast } from "@/js/alertPopShow";
import loading from "@/components/loading"
import axios from 'axios'
const punycode = require('punycode');
// import $ from 'jquery'
export default {
  components:{
    loading
  },
  // axios
  postData(url,data,success,complate){
    // console.log(punycode.encode('优学尚'));// 6qq79v
    // var name = punycode.decode('4oqv31appa');
    // var that = this;
    // var address = 'http://exam.'+ name +'.com/'
    // console.log(address);
    var address = 'http://yxs.ayunlian.com/';
    axios({
      url: address + url,
      method:'post',
      data:data
    })
      .then(function (res) {
        if(res.data.status == 200){
          success && success(res.data);
        }
        if( res.data.status == 404 ){
          webToast(res.data.message,'middle',1500);
        }
        if( res.data.status == 502 ){
          webToast(res.data.message,'middle',1500);
          window.location.href = '/login';
        }
        if( res.data.status == 503 ){
          success && success(res.data);
          // webToast(res.data.message,'middle',1500);
        }
      })
      .finally(function () {
        // always executed
        complate && complate();
      });
  },

  postData2(url,data,success,complate){
    var that = this;
    var address = 'http://yxs.ayunlian.com/';
    axios({
      url: address + url,
      method:'post',
      data:data
    })
      .then(function (res) {
        if(res.data.status == 200){
          success && success(res.data);
        }
        if( res.data.status == 404 ){
          success && success(res.data);
          // webToast(res.data.message,'middle',1500);
        }
        if( res.data.status == 502 ){
          webToast(res.data.message,'middle',1500);
          window.location.href = '/login';
        }
        if( res.data.status == 503 ){
          success && success(res.data);
          // webToast(res.data.message,'middle',1500);
        }
      })
      .finally(function () {
        // always executed
        complate && complate();
      });
  },

  // 返回上一页
  returnPage(){
    var that = this;
    that.$router.go(-1);
  },
  hideSuccess(val,callback){
    var hideSuccess = setTimeout(function () {
      val = false;
      console.log('123');
      callback && callBack()
    },1500)
  }
}



// WEBPACK FOOTER //
// ./src/js/common.js